"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemPressButton = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const helpler_1 = require("../../utils/helpler");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const MenuItemPressButton = (props) => {
    const { title = '', style = {}, ...rest } = props;
    return react_1.default.createElement(react_native_1.Pressable
    // @ts-ignore
    , { 
        // @ts-ignore
        style: ({ hovered, pressed }) => [styles.viewLine, (pressed || hovered) && styles.activeButton, style], ...rest },
        react_1.default.createElement(CustomText_1.default, { style: styles.textNote }, title));
};
exports.MenuItemPressButton = MenuItemPressButton;
const ModalSubUser = (props) => {
    const { visible, onClose, modalPosition, data, openModalNoti, openModalShare, displayTweet, onBlock, onMute, OnFollow, OnUnFollow, OnUnBlock, OnUnMute, } = props;
    const distanceFromBottom = react_native_1.Dimensions.get("window").height - modalPosition.y;
    const dataUser = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile, react_redux_1.shallowEqual);
    const [modalHeight, setModalHeight] = (0, react_1.useState)(320);
    const userId = data?.userId || data?.user_id;
    const dataListFollow = (0, react_redux_1.useSelector)((state) => state?.listFollowReducer?.listFollow, react_redux_1.shallowEqual);
    const checkFollow = dataListFollow.some((item) => item == userId);
    const dataListBlock = (0, react_redux_1.useSelector)((state) => state?.listBlockReducer?.listBlock, react_redux_1.shallowEqual);
    const checkBlock = dataListBlock.some((item) => item == userId);
    const dataListMute = (0, react_redux_1.useSelector)((state) => state?.listMuteReducer?.listMute, react_redux_1.shallowEqual);
    const checkMute = dataListMute.some((item) => item == userId);
    const handleLayout = (event) => {
        const { height } = event.nativeEvent.layout;
        setModalHeight(height);
    };
    return (react_1.default.createElement(react_native_1.Modal, { visible: visible, animationType: "none", statusBarTranslucent: true, transparent: true, onRequestClose: onClose, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        }, ...props },
        react_1.default.createElement(react_native_1.TouchableOpacity, { activeOpacity: 1, style: styles.viewContain, onPress: () => {
                onClose();
            } },
            react_1.default.createElement(react_native_1.View, { style: [
                    styles.viewModal,
                    {
                        position: 'absolute',
                        top: distanceFromBottom > (0, scale_1.scale)(modalHeight) ||
                            dataUser?.registration_status == 0
                            ? modalPosition.y + (0, scale_1.scale)(4)
                            : (modalPosition.y - (0, scale_1.scale)(modalHeight) < 0
                                ? (0, scale_1.scale)(50)
                                : modalPosition.y - modalHeight - (0, scale_1.scale)(26 + 4)),
                        left: modalPosition.x - (0, scale_1.scale)(220),
                    },
                ], onLayout: handleLayout },
                dataUser?.registration_status != 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(exports.MenuItemPressButton, { title: `@${data?.user_handle || data?.userHandle}${checkFollow ? 'を\nフォロー解除' : `を\nフォロー`}`, onPress: () => {
                            checkFollow ? OnUnFollow() : OnFollow();
                        } }),
                    react_1.default.createElement(exports.MenuItemPressButton, { title: `@${data?.user_handle || data?.userHandle}${checkBlock ? `を\nブロック解除` : `を\nブロック`}`, onPress: () => {
                            checkBlock ? OnUnBlock?.() : onBlock();
                        } }),
                    react_1.default.createElement(exports.MenuItemPressButton, { title: `@${data?.user_handle || data?.userHandle}${checkMute ? `を\nミュート解除` : `を\nミュート`}`, onPress: () => {
                            checkMute ? OnUnMute?.() : onMute();
                        } }))),
                react_1.default.createElement(exports.MenuItemPressButton, { style: dataUser?.registration_status === 0 && { borderBottomColor: 'transparent' }, title: `共有`, onPress: openModalShare }),
                dataUser?.registration_status != 0 && (react_1.default.createElement(exports.MenuItemPressButton, { style: { borderBottomColor: 'transparent' }, title: `通報`, onPress: openModalNoti })
                // <TouchableOpacity
                // 	style={{
                // 		paddingHorizontal: scale(20),
                // 		paddingVertical: scale(16),
                // 		backgroundColor: "#DDDDDD",
                // 	}}
                // 	onPress={() => {
                // 		openModalNoti()
                // 	}}
                // >
                // 	<CustomText style={styles.textNote}>{`通報`}</CustomText>
                // </TouchableOpacity>
                )))));
};
const styles = react_native_1.StyleSheet.create({
    viewLine: {
        borderBottomWidth: 1,
        borderBottomColor: "#ADADAD",
        paddingHorizontal: (0, scale_1.scale)(20),
        paddingVertical: (0, scale_1.scale)(16),
        backgroundColor: "#DDDDDD",
    },
    textConfirm: {
        color: "#FFFFFF",
    },
    textNote: {
        fontWeight: "300",
        fontSize: (0, scale_1.moderateScale)(14),
        color: "#292A33",
        lineHeight: (0, scale_1.moderateScale)(21),
    },
    viewModal: {
        backgroundColor: "#DDDDDD",
        width: (0, scale_1.scale)(220),
        borderRadius: (0, scale_1.scale)(6),
        overflow: 'hidden',
    },
    viewContain: {
        flex: 1,
    },
    activeButton: {
        backgroundColor: '#C8C8C8',
        ...react_native_1.Platform.select({
            web: {
                transitionProperty: 'all',
                transitionDuration: '300ms',
                transitionTimingFunction: 'ease',
            },
        }),
    }
});
exports.default = ModalSubUser;
